import React, { useState, useMemo } from "react";
import Select from "react-select";
import { FixedSizeList as List } from "react-window";
import escapeRegExp from "lodash/escapeRegExp";

const height = 35;

const MenuList = (props) => {
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;

  return (
    <List
      height={maxHeight}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

const SelectReact = ({options, onChange, defaultValue}) => {
  const [inputValue, setInputValue] = useState("");

  const filteredOptions = useMemo(() => {
    if (!inputValue) {
      return options;
    }

    const matchByStart = [];
    const matchByInclusion = [];

    const regByInclusion = new RegExp(escapeRegExp(inputValue), "i");
    const regByStart = new RegExp(`^${escapeRegExp(inputValue)}`, "i");

    for (const option of options) {
      if (regByInclusion.test(option.label)) {
        if (regByStart.test(option.label)) {
          matchByStart.push(option);
        } else {
          matchByInclusion.push(option);
        }
      }
    }

    return [...matchByStart, ...matchByInclusion];
  }, [inputValue, options]);

  return (
    <Select
      components={{ MenuList }}
      className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
      options={filteredOptions}
      onInputChange={(value) => setInputValue(value)}
      filterOption={() => true}
      value={{
        value: defaultValue,
        label: filteredOptions.find((option) => Number(option.value) === Number(defaultValue))?.label,
      }}
      onChange={onChange}
    />
  );
};

export default SelectReact;